import _ from 'lodash';

enum Environment {
  DEV = 'dev',
  QA = 'qa',
  UAT = 'uat',
  PROD = 'prod',
}

let currentEnvironment = '';
let isLocal = false;

const origin = _.get(window, 'location.origin', '');

if (origin.includes('localhost') || origin.includes('dev')) {
  currentEnvironment = Environment.DEV;
  isLocal = origin.includes('localhost');
} else if (origin.includes('int') || origin.includes('qa')) {
  currentEnvironment = Environment.QA;
} else if (origin.includes('stg') || origin.includes('uat')) {
  currentEnvironment = Environment.UAT;
} else {
  currentEnvironment = Environment.PROD;
}
export { currentEnvironment, isLocal };